'use client'
import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import type { RangeKeyDict, Range } from 'react-date-range'

const DateRangePicker = dynamic(
  () =>
    import('react-date-range').then(
      (module) => module.DateRangePicker as React.ComponentType<any>,
    ),
  { ssr: false },
)

const Calendar = ({
  handleDate,
  defaultRange,
}: {
  handleDate: (startDate: Date, endDate: Date) => void
  defaultRange: { startDate: Date; endDate: Date }
}) => {
  const [selectionRange, setSelectionRange] = useState<Range>({
    ...defaultRange,
    key: 'selection',
  })

  const handleSelect = (ranges: RangeKeyDict) => {
    const selection = ranges.selection
    if (selection.startDate && selection.endDate) {
      setSelectionRange({
        ...selection,
        startDate: selection.startDate,
        endDate: selection.endDate,
      })
    }
  }

  const { startDate, endDate } = selectionRange
  useEffect(() => {
    if (startDate && endDate) {
      handleDate(startDate, endDate)
    }
  }, [startDate, endDate])

  const disableFutureDates = (date: Date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return date > today
  }

  return (
    <>
    {/* @ts-ignore */}
      <DateRangePicker
        editableDateInputs={true}
        moveRangeOnFirstSelection={false}
        ranges={[selectionRange]}
        onChange={handleSelect}
        rangeColors={['#24BFA3']}
        disabledDay={disableFutureDates}
      />
    </>
  )
}

export default Calendar
